import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    windowKey: 'blick_theme',
    autoThemeStyleElementId: 'auto-dark-mode-styles',
  }) as const) satisfies ConfigFn

export default config
